<span
  bottom
  [class]="'bar-button bar-button-ico fa-solid fa-calculator'"
  [pTooltip]="buttonTitle|translate"
  (click)="op.toggle($event)">
</span>
<p-overlayPanel #op [showCloseIcon]="true" [style.width]="'400px'" [style.minWidth]="'400px'" [style.maxWidth]="'400px'"
                [dismissable]="true" [styleClass]="'top-overlay'">
  <ng-template pTemplate>
    <app-hogo class="hogo" [transPartKey]="transPartKey"
              [visible]="op.overlayVisible" [gasOilPricesCountLimitStr]="gasOilPricesCountLimitStr"></app-hogo>
  </ng-template>
</p-overlayPanel>
